import React from 'react';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import SelectField from 'material-ui/SelectField';

const muiTheme = getMuiTheme({
    palette: {
     // textColor: 'white',
    },
    selectField: {
      color: 'white',
    },

  });

function StyledSelectField({children, ...rest}) {
  return (
    <MuiThemeProvider muiTheme={muiTheme}>
      <div style={{marginBottom: '-11px'}}>
        <SelectField {...rest}
        menuStyle = {{color: 'white',}}
        menuItemStyle = {{color: 'gray', }}
        labelStyle = {{color: 'gray', letterSpacing: '0.08em', fontSize: 14, marginLeft: 15, }}
        selectedMenuItemStyle = {{color: 'gray'}}
        hintStyle = {{color: '#95989A', letterSpacing: '0.08em', fontSize: 14, marginLeft: 15, }}
        // maxHeight = {10}
        // floatingLabelStyle = {{color: 'rgba(255, 255, 255, 0.64)', letterSpacing: '0.08em', fontSize: 14, marginLeft: 15, }}
        // autoWidth = {true}
        style = {{
          color: '#C6CACC', 
          borderWidth: 2,
          borderColor: '#C6CACC',
          borderStyle: 'solid',
          borderRadius: 15,
          width: rest.width,
          // marginRight: 20,
          // height: 30,
        //  marginBottom: '-60px',
        }}
        underlineStyle  = {{
          borderWidth: 0,
          borderColor: '',
          borderStyle: 'none',
          marginLeft: 15,

        }}
          // //style={selectFieldStyles}
          // multiple={props.multiple}
          // hintText={props.hintText}
          // value={props.value}
          // onChange={props.onChange}
        >
            {children ? children : 'no child'}
        </SelectField>
      </div>
    </MuiThemeProvider>

  );
}

// StyledSelectField.propTypes = {
//  // children: PropTypes.node,
//   //classes: PropTypes.object.isRequired,
// };

export default StyledSelectField;


// WEBPACK FOOTER //
// ./src/js/components/StyledSelectField.jsx